import React from 'react'
import { Container, Group } from '@mantine/core'
import Head from 'next/head'

import { FooterWrapper, GridBackground } from 'components/site'
import { ResponsiveHead } from 'components/ui'
import SiteLayout from 'components/site/SiteLayout'
import Jumbotron from 'modules/Site/Templates/Jumbotron'
import { CampaignTemplateCategories } from 'components/business'
import CategoryAffixTab from 'modules/Site/Templates/CategoryAffixTab'
import { GetStaticProps } from 'next'
import { CampaignTemplate, CampaignTemplatesBasicInfoDocument } from 'types/domain'
import { initializeApollo } from 'plugins/apollo'

type Props = {
  templates: CampaignTemplate[]
}
const TemplatesPage = ({ templates }: Props) => {
  return (
    <SiteLayout>
      <Head>
        <title>场景模板 - 浩客HowXM模板中心 - 应用内调研、评价、通知模板 - NPS 调研模板 - 评价反馈模板</title>
      </Head>
      <ResponsiveHead />
      <GridBackground>
        <Container size={1200} className="pb-11 pt-[123px]" px={0}>
          <Jumbotron className="sm:mb-[26px] mb-[28px]" />
          <Group position="center" mb={42}>
            <CategoryAffixTab />
          </Group>
          <CampaignTemplateCategories templates={templates} source="site" />
        </Container>
      </GridBackground>
      <FooterWrapper className="pt-[159px]" />
    </SiteLayout>
  )
}

export default TemplatesPage

export const getStaticProps: GetStaticProps<{
  templates: CampaignTemplate[]
}> = async () => {
  const pageKeywords = '场景模板,NPS调研模板,评价反馈模板,满意度调研模板,应用内调研模板,横幅通知模板,用户调研模板'
  const pageDescription =
    '浩客HowXM，数字化系统的应用内调研、评价、通知工具，简单好用的用户体验分析工具，场景模板包括：用户体验、用户引导、用户研究、运营增长、产品迭代、横幅通知等类别，比如：NPS 净推荐值调研，CSAT 满意度调研，评价反馈模板，新功能通知，促销通知模板，付费流失原因调研，A/B 版本测试，新功能引导模板等。'
  try {
    const { data } = await initializeApollo().query({
      query: CampaignTemplatesBasicInfoDocument,
    })
    return {
      props: {
        templates: data?.campaignTemplates,
        pageKeywords,
        pageDescription,
      },
    }
  } catch (error) {
    console.error(error)
    return {
      props: {
        templates: [],
        pageKeywords,
        pageDescription,
      },
    }
  }
}
